import React from 'react';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Checkbox } from 'antd';
import intl from 'react-intl-universal';
import './index.scss';

const { Item } = Form;

export default class SearchPanel extends React.Component {
    constructor(...props) {
        super(...props);
    }

    onChangeIgnoreAsia = (e) => {
        this.props.searchChange('isIgnoreAsia', e.target.checked);
    }

    onChangeIgnoreDiacritics = (e) => {
        this.props.searchChange('isIgnoreDiacritics', e.target.checked);
    }

    onChangeAlwaysShowMore = (e) => {
        this.props.searchChange('isAlwaysShowMore', e.target.checked);
    }

    render() {
        const searchTitle = intl.formatMessage({ id: 'Preferences.Content.Search.Title' });
        const ignoreAsia = intl.formatMessage({ id: 'Preferences.Content.Search.IgnoreAsia' });
        const ignoreDiacritics = intl.formatMessage({ id: 'Preferences.Content.Search.IgnoreDiacritics' });
        const alwaysShowMore = intl.formatMessage({ id: 'Preferences.Content.Search.AlwaysShowMore' });

        return (
            <div className="preferences-search">
                <Form
                    labelCol={{ span: 7 }}
                    wrapperCol={{
                        span: 24
                    }}
                    name="search"
                    size='small'>
                        <div className="title">{searchTitle}</div>
                        <div className="board LayoutGrid">
                            <Item name="ignoreAsia" className="custom-item">
                                <Checkbox
                                    checked={this.props.searchPreference.isIgnoreAsia}
                                    onChange={this.onChangeIgnoreAsia}
                                >
                                    {ignoreAsia}
                                </Checkbox>
                            </Item>
                            <Item name="ignoreDiacritics" className="custom-item">
                                <Checkbox
                                    checked={this.props.searchPreference.isIgnoreDiacritics}
                                    onChange={this.onChangeIgnoreDiacritics}
                                >
                                    {ignoreDiacritics}
                                </Checkbox>
                            </Item>
                            <Item name="alwaysShowMore" className="custom-item">
                                <Checkbox
                                    checked={this.props.searchPreference.isAlwaysShowMore}
                                    onChange={this.onChangeAlwaysShowMore}
                                >
                                    {alwaysShowMore}
                                </Checkbox>
                            </Item>
                        </div>
                </Form>
            </div>
        );
    }
}